/* P&lll Aurora Pro - Theme JS */

document.addEventListener('DOMContentLoaded', function() {
  // --- Navbar scroll effect ---
  const navbar = document.querySelector('.navbar');
  if (navbar) {
    window.addEventListener('scroll', function() {
      navbar.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  // --- Mobile menu ---
  const mobileToggle = document.querySelector('.mobile-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileOverlay = document.querySelector('.mobile-overlay');
  const mobileClose = document.querySelector('.mobile-menu-close');

  function openMobile() {
    mobileMenu && mobileMenu.classList.add('open');
    mobileOverlay && mobileOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobile() {
    mobileMenu && mobileMenu.classList.remove('open');
    mobileOverlay && mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  mobileToggle && mobileToggle.addEventListener('click', openMobile);
  mobileClose && mobileClose.addEventListener('click', closeMobile);
  mobileOverlay && mobileOverlay.addEventListener('click', closeMobile);
  document.querySelectorAll('.mobile-menu-nav a').forEach(function(a) {
    a.addEventListener('click', closeMobile);
  });

  // --- Scroll animations (IntersectionObserver) ---
  function initScrollAnimations(root) {
    var els = (root || document).querySelectorAll('.animate-on-scroll:not(.visible)');
    if (els.length === 0) return;
    // In Shopify editor, make all elements visible immediately
    if (document.documentElement.classList.contains('shopify-design-mode')) {
      els.forEach(function(el) { el.classList.add('visible'); });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function(el) { observer.observe(el); });
  }
  initScrollAnimations(document);

  // Re-initialize when Shopify editor reloads a section
  document.addEventListener('shopify:section:load', function(e) {
    initScrollAnimations(e.target);
  });

  // --- FAQ accordion ---
  document.querySelectorAll('.faq-question').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const item = this.closest('.faq-item');
      const answer = item.querySelector('.faq-answer');
      const isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.faq-item').forEach(function(fi) {
        fi.classList.remove('open');
        fi.querySelector('.faq-answer').style.maxHeight = null;
      });

      // Open clicked (if wasn't open)
      if (!isOpen) {
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });

  // --- Tech Specs filter ---
  document.querySelectorAll('.spec-cat-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const cat = this.dataset.category;
      document.querySelectorAll('.spec-cat-btn').forEach(function(b) { b.classList.remove('active'); });
      this.classList.add('active');

      document.querySelectorAll('.spec-row').forEach(function(row) {
        if (cat === 'ALL' || row.dataset.category === cat) {
          row.style.display = '';
        } else {
          row.style.display = 'none';
        }
      });

      // Update count
      const visible = document.querySelectorAll('.spec-row:not([style*="display: none"])').length;
      const countEl = document.querySelector('.specs-count');
      if (countEl) countEl.textContent = 'TOTAL: ' + visible + ' PARAMETERS';
      const catEl = document.querySelector('.specs-active-cat');
      if (catEl) catEl.textContent = 'CATEGORY: ' + cat;
    });
  });

  // --- Light Cards Hover Glow ---
  document.querySelectorAll('.light-card').forEach(function(card) {
    card.addEventListener('mouseenter', function() {
      var bar = card.querySelector('.light-card-bar');
      if (bar) {
        var color = bar.classList.contains('light-card-bar--yellow') ? 'rgba(250,204,21,0.15)'
          : bar.classList.contains('light-card-bar--orange') ? 'rgba(251,146,60,0.15)'
          : bar.classList.contains('light-card-bar--red') ? 'rgba(248,113,113,0.15)'
          : 'rgba(168,85,247,0.15)';
        card.style.boxShadow = '0 0 40px ' + color;
        card.style.transform = 'translateY(-4px)';
      }
    });
    card.addEventListener('mouseleave', function() {
      card.style.boxShadow = '';
      card.style.transform = '';
    });
  });

  // --- Diff Cards Hover ---
  document.querySelectorAll('.diff-card').forEach(function(card) {
    card.addEventListener('mouseenter', function() {
      card.style.transform = 'translateY(-6px)';
      card.style.boxShadow = '0 0 30px rgba(250,204,21,0.15)';
    });
    card.addEventListener('mouseleave', function() {
      card.style.transform = '';
      card.style.boxShadow = '';
    });
  });

  // --- Newsletter Popup (Shopify customer form; auto-shows success after redirect) ---
  (function initNewsletterPopup() {
    const popup = document.querySelector('[data-newsletter-popup]');
    if (!popup) return;

    const KEY_DISMISSED  = 'plll_newsletter_dismissed_at';
    const KEY_SUBSCRIBED = 'plll_newsletter_subscribed';
    const delaySec = parseInt(popup.dataset.delay || '5', 10);
    const freqDays = parseInt(popup.dataset.frequency || '7', 10);
    const cooldownMs = freqDays * 24 * 60 * 60 * 1000;

    const params = new URLSearchParams(location.search);
    const justPosted = params.get('customer_posted') === 'true';

    function show() {
      popup.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }
    function hide() {
      popup.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }
    function dismissAndStore() {
      hide();
      try { localStorage.setItem(KEY_DISMISSED, String(Date.now())); } catch (e) {}
    }
    function markSubscribed() {
      try { localStorage.setItem(KEY_SUBSCRIBED, 'true'); } catch (e) {}
    }

    // 1. Just submitted — show success state, mark subscribed, auto-close
    if (justPosted) {
      const content = popup.querySelector('[data-newsletter-content]');
      const success = popup.querySelector('[data-newsletter-success]');
      if (content && success) {
        content.hidden = true;
        success.hidden = false;
      }
      markSubscribed();
      show();
      setTimeout(hide, 4000);
      try {
        params.delete('customer_posted');
        const cleanUrl = location.pathname + (params.toString() ? '?' + params : '') + location.hash;
        history.replaceState({}, '', cleanUrl);
      } catch (e) {}
      return;
    }

    // 2. Already subscribed — never show again
    try {
      if (localStorage.getItem(KEY_SUBSCRIBED)) return;
    } catch (e) {}

    // 3. Recently dismissed — skip until cooldown passes
    try {
      const dismissedAt = parseInt(localStorage.getItem(KEY_DISMISSED) || '0', 10);
      if (dismissedAt && (Date.now() - dismissedAt) < cooldownMs) return;
    } catch (e) {}

    // 4. Delay then show
    setTimeout(show, delaySec * 1000);

    // 5. Close handlers
    popup.querySelectorAll('[data-newsletter-close]').forEach(function(el) {
      el.addEventListener('click', dismissAndStore);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && !popup.hasAttribute('hidden')) dismissAndStore();
    });
  })();

  // --- Product Media Gallery (thumbnail switching) ---
  const galleryThumbs = document.querySelectorAll('.gallery-thumb');
  const gallerySlides = document.querySelectorAll('.gallery-slide');
  if (galleryThumbs.length && gallerySlides.length) {
    galleryThumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const id = thumb.getAttribute('data-media-id');
        galleryThumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        gallerySlides.forEach(function(slide) {
          const isActive = slide.getAttribute('data-media-id') === id;
          slide.classList.toggle('active', isActive);
          if (!isActive) {
            const v = slide.querySelector('video');
            if (v && !v.paused) v.pause();
            const iframe = slide.querySelector('iframe');
            if (iframe) {
              const src = iframe.getAttribute('src');
              iframe.setAttribute('src', src);
            }
          }
        });
      });
    });
  }

  // --- Add to Cart (Shopify) ---
  const addToCartForm = document.querySelector('.product-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(this);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        window.location.href = '/cart';
      })
      .catch(function(err) {
        console.error('Add to cart error:', err);
      });
    });
  }
});
